(function () {
  'use strict';

  const root = document.querySelector('[data-wig-cart]');
  if (!root) return;

  const sectionId = root.dataset.sectionId;

  const refreshSection = async () => {
    if (!sectionId) {
      window.location.reload();
      return;
    }
    root.classList.add('is-updating');
    try {
      const url = `${window.location.pathname}?section_id=${encodeURIComponent(sectionId)}`;
      const response = await fetch(url);
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newRoot = doc.querySelector('[data-wig-cart]');
      if (newRoot) {
        root.innerHTML = newRoot.innerHTML;
        bindEvents();
      } else {
        window.location.reload();
      }
    } catch (error) {
      console.error('[wig-cart]', error);
      window.location.reload();
    } finally {
      root.classList.remove('is-updating');
    }
  };

  const changeQuantity = async (lineKey, quantity) => {
    root.classList.add('is-updating');
    try {
      const body = { id: lineKey, quantity: Math.max(0, quantity) };
      if (sectionId) {
        body.sections = sectionId;
        body.sections_url = window.location.pathname;
      }
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      const data = await response.json();
      if (data.status) throw new Error(data.description || data.message);
      if (data.sections && data.sections[sectionId]) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(data.sections[sectionId], 'text/html');
        const newRoot = doc.querySelector('[data-wig-cart]');
        if (newRoot) {
          root.innerHTML = newRoot.innerHTML;
          bindEvents();
          return;
        }
      }
      await refreshSection();
    } catch (error) {
      console.error('[wig-cart]', error);
      await refreshSection();
    } finally {
      root.classList.remove('is-updating');
    }
  };

  const applyDiscount = async (code) => {
    const errorEl = root.querySelector('[data-cart-discount-error]');
    if (errorEl) {
      errorEl.hidden = true;
      errorEl.textContent = '';
    }
    root.classList.add('is-updating');
    try {
      const body = { discount: code };
      if (sectionId) {
        body.sections = sectionId;
        body.sections_url = window.location.pathname;
      }
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      const data = await response.json();
      if (!response.ok) throw data;
      if (data.sections && data.sections[sectionId]) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(data.sections[sectionId], 'text/html');
        const newRoot = doc.querySelector('[data-wig-cart]');
        if (newRoot) {
          root.innerHTML = newRoot.innerHTML;
          bindEvents();
          return;
        }
      }
      await refreshSection();
    } catch (error) {
      if (errorEl) {
        errorEl.hidden = false;
        errorEl.textContent = error?.description || error?.message || 'Invalid discount code';
      }
    } finally {
      root.classList.remove('is-updating');
    }
  };

  const addRecommendation = async (variantId, button) => {
    if (!variantId) return;
    button.disabled = true;
    try {
      const body = { items: [{ id: Number(variantId), quantity: 1 }] };
      if (sectionId) {
        body.sections = sectionId;
        body.sections_url = window.location.pathname;
      }
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      const data = await response.json();
      if (data.status) throw new Error(data.description);
      if (data.sections && data.sections[sectionId]) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(data.sections[sectionId], 'text/html');
        const newRoot = doc.querySelector('[data-wig-cart]');
        if (newRoot) {
          root.innerHTML = newRoot.innerHTML;
          bindEvents();
          return;
        }
      }
      await refreshSection();
    } catch (error) {
      console.error('[wig-cart]', error);
      button.disabled = false;
    }
  };

  const copyCode = async (code, button) => {
    try {
      await navigator.clipboard.writeText(code);
      const original = button.textContent;
      button.textContent = 'Copied!';
      window.setTimeout(() => {
        button.textContent = original;
      }, 1500);
    } catch {
      window.prompt('Copy code:', code);
    }
  };

  const initCountdown = () => {
    const el = root.querySelector('[data-cart-countdown]');
    if (!el?.dataset.end) return;
    const end = new Date(el.dataset.end).getTime();
    if (Number.isNaN(end)) return;

    const tick = () => {
      const diff = Math.max(0, end - Date.now());
      const h = Math.floor(diff / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      const s = Math.floor((diff % 60000) / 1000);
      const hEl = el.querySelector('[data-cart-countdown-h]');
      const mEl = el.querySelector('[data-cart-countdown-m]');
      const sEl = el.querySelector('[data-cart-countdown-s]');
      if (hEl) hEl.textContent = String(h).padStart(2, '0');
      if (mEl) mEl.textContent = String(m).padStart(2, '0');
      if (sEl) sEl.textContent = String(s).padStart(2, '0');
    };

    tick();
    window.setInterval(tick, 1000);
  };

  const bindEvents = () => {
    root.querySelectorAll('[data-cart-qty]').forEach((btn) => {
      btn.addEventListener('click', () => {
        changeQuantity(btn.dataset.lineKey, parseInt(btn.dataset.quantity, 10));
      });
    });

    root.querySelectorAll('[data-cart-qty-input]').forEach((input) => {
      input.addEventListener('change', () => {
        changeQuantity(input.dataset.lineKey, parseInt(input.value, 10) || 0);
      });
    });

    root.querySelectorAll('[data-cart-remove]').forEach((btn) => {
      btn.addEventListener('click', () => {
        changeQuantity(btn.dataset.lineKey, 0);
      });
    });

    const discountBtn = root.querySelector('[data-cart-discount-apply]');
    const discountInput = root.querySelector('[data-cart-discount-input]');
    if (discountBtn && discountInput) {
      discountBtn.addEventListener('click', () => {
        const code = discountInput.value.trim();
        if (code) applyDiscount(code);
      });
      discountInput.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          discountBtn.click();
        }
      });
    }

    root.querySelectorAll('[data-copy-code]').forEach((btn) => {
      btn.addEventListener('click', () => copyCode(btn.dataset.copyCode, btn));
    });

    root.querySelectorAll('[data-rec-add]').forEach((btn) => {
      btn.addEventListener('click', () => addRecommendation(btn.dataset.variantId, btn));
    });

    root.querySelectorAll('[data-upsell-add]').forEach((btn) => {
      btn.addEventListener('click', () => addRecommendation(btn.dataset.variantId, btn));
    });

    initCountdown();
  };

  bindEvents();
})();
